var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecoDiagonals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 21,
    viewBox: "0 0 111 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3982 0L3.80827 20.9999H0L0 17.9121L15.8574 0L22.3982 0Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38464 0L0 10.5977L0 3.20645L2.83765 0L9.38464 0Z",
    fill: "#FF9900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4556 0L16.8719 20.9999H10.3311L28.9148 0L35.4556 0Z",
    fill: "#FF9900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4253 0L29.8416 20.9999H23.3008L41.8845 0L48.4253 0Z",
    fill: "#FF9900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 0L42.8992 20.9999H36.3584L54.9483 0L61.4829 0Z",
    fill: "#FF9900"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5884 0L56.0047 20.9999H49.4639L68.0476 0L74.5884 0Z",
    fill: "#FF9900"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6522 0L69.0685 20.9999H62.5215L81.1114 0L87.6522 0Z",
    fill: "#FF9900"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.622 0L82.0316 20.9999H75.4971L94.0808 0L100.622 0Z",
    fill: "#FF9900"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.848 0V3.19963L95.0954 20.9999H88.5547L107.138 0L110.848 0Z",
    fill: "#FF9900"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.848 10.5139V17.9123L108.109 21H101.568L110.848 10.5139Z",
    fill: "#FF9900"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoDiagonals);
export default __webpack_public_path__ + "static/media/deco-diagonals.9998ba378bbe700eb80a8ad92c604cc0.svg";
export { ForwardRef as ReactComponent };